import {t} from "i18next";

import FunctionButton from "../../../utilities/Buttons/FunctionButton";
import IconButton from "../../../utilities/Buttons/IconButton";
import Divider from "../../../utilities/Divider/Divider";
import {ICON_NAMES} from "../../../utilities/generalConstants.js/generalConstants";
import ToolTip from "../../../utilities/ToolTip";
import {UI_PERMISSION_TYPE} from "../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import ReactTable from "../../conteiners/ReactTable";
import {DateInput, TextAreaInput} from "../../Inputs";
import PdfFilePreview from "../../Inputs/fileSelect/preview/PdfPreview";
import {Select} from "../../Inputs/SelectField";
import NewPdfViewer from "../../Project/Documents/DocumentView/NewPdfViewer";

import useDevTicketsList from "./useDevTicketsList";

const DevTicketsListBody = ({changePage, onPaginate, page}) => {
  const {
    fileArray,
    ticketsTableColumns,
    ticketsTableData,
    onTakeIntoWorkBtnClick,
    onSaveBtnClick,
    onReadyBtnClick,
    ITManagersOptions,
    managerITTableData,
    onTicketsTableSelect,
    currentTicketId,
    currentTicket,
    loading,
    isCurrentTicketInWork,
    isCurrentTicketClosed,
    files,
    onAddTicketFile,
    onDeleteTicketFile,
    hasItNoteChanged,
    hasTaskDataChanged,
    onCancelTakeIntoWorkBtnClick,
  } = useDevTicketsList({changePage, page});

  return (
    <div className="grid2ColFirstBigger fGrow pb fShrink maxH100" style={{gridTemplateColumns: "minmax(0, 1fr) 30%"}}>
      <div className="fcCol gap0_5 pt5  maxH100">
        <ReactTable
          columns={ticketsTableColumns}
          defaultData={ticketsTableData}
          className="fGrow scrollX scrollY fShrink"
          current={currentTicketId}
          onSelect={onTicketsTableSelect}
          loading={loading}
          style={{
            height: "13em",
          }}
          onPaginate={onPaginate}
          currentPage={page?.currentPage}
          totalPages={page?.totalPages}
          paginatable
          paginationPageView
        />
        <ToolTip title={currentTicketId ? "appeal text" : ""} className="w100 ">
          <TextAreaInput name="ticketText" height="8rem" placeholder={t("appeal text")} readOnly className="fcCol" />
        </ToolTip>

        <Divider />
        <div className="w100 fc nowrap">
          <div className="fGrow fcCol gap0_5">
            <div className="row w100 jcsb aic">
              <FunctionButton
                name={isCurrentTicketInWork ? "Back to status 'New'" : "Take into work"}
                onClick={isCurrentTicketInWork ? onCancelTakeIntoWorkBtnClick : onTakeIntoWorkBtnClick}
                autoWidth
                disabled={!currentTicketId || isCurrentTicketClosed || currentTicket?.tasks?.length > 1}
                uiPermissionType={UI_PERMISSION_TYPE.READABLE}
              />
              <div className="row aife gap">
                <Select
                  label="IT Manager"
                  options={ITManagersOptions}
                  name="itManagerId"
                  width="20rem"
                  optionsAbove
                  disabled={!currentTicketId || !isCurrentTicketInWork}
                  required
                  uiPermissionType={UI_PERMISSION_TYPE.READABLE}
                />
                <DateInput
                  label="Plan Date"
                  name="planDate"
                  fromCurrentDate
                  disabled={!currentTicketId || !isCurrentTicketInWork}
                  required
                  uiPermissionType={UI_PERMISSION_TYPE.READABLE}
                />
                {/* <CheckBox
                  type="checkbox"
                  name="isDone"
                  disabled={!currentTicketId || !isCurrentTicketInWork || !currentTaskId}
                  tooltipMessage={currentTicketId ? "sign task ready" : ""}
                /> */}
              </div>
            </div>
            <div className=" w100">
              <TextAreaInput
                name="itNote"
                placeholder={t("appeal IT response text")}
                style={{height: "unset", width: "100%"}}
                disabled={!currentTicketId}
                uiPermissionType={UI_PERMISSION_TYPE.READABLE}
              />
              {/* <div className="fc aic" style={{height: "8rem"}}>
                <ReactTable
                  columns={managerITTableColumns}
                  defaultData={managerITTableData}
                  current={currentTaskId}
                  onSelect={onManagerITTableSelect}
                  loading={currentTicketId && loading}
                />
              </div> */}
            </div>
          </div>
          <div className="fcCol jcsa gap h100 pl">
            <IconButton
              nameIcon={ICON_NAMES.SAVE}
              widthIcon={18}
              heightIcon={18}
              onClick={onSaveBtnClick}
              disabled={!currentTicketId || !(hasItNoteChanged || hasTaskDataChanged)}
              ariaLabel="Save"
              uiPermissionType={UI_PERMISSION_TYPE.READABLE}
            />
            {/* <ImageButton
              src={SaveIcon}
              size={2.2}
              onClick={onSaveBtnClick}
              disabled={!currentTicketId || !(hasItNoteChanged || hasTaskDataChanged)}
            /> */}
            <PdfFilePreview
              files={files}
              delFunc={onDeleteTicketFile}
              addFunc={onAddTicketFile}
              disabled={!currentTicketId || !isCurrentTicketInWork}
              loading={loading}
              width={2.6}
              height={2}
              accept={".jpg,.jpeg,.png,.webp"}
              uiPermissionType={UI_PERMISSION_TYPE.READABLE}
            />
            <IconButton
              nameIcon={ICON_NAMES.READY}
              widthIcon={18}
              heightIcon={18}
              onClick={onReadyBtnClick}
              disabled={!currentTicketId || managerITTableData?.length < 1}
              tooltipMessage={isCurrentTicketClosed ? "reopen ticket" : currentTicketId ? "sign ready" : ""}
              classNameIcon={isCurrentTicketClosed ? "icon-ready" : ""}
              uiPermissionType={UI_PERMISSION_TYPE.READABLE}
            />
            {/* <ImageButton
              src={ReadyIcon}
              size={2.2}
              onClick={onReadyBtnClick}
              disabled={!currentTicketId || managerITTableData?.length < 1}
              tooltipMessage={isCurrentTicketClosed ? "reopen ticket" : currentTicketId ? "sign ready" : ""}
              className={isCurrentTicketClosed ? "pressed" : ""}
            /> */}
          </div>
        </div>
      </div>
      <div className="kpPreview__box pdfViewerContain w100 h100">
        <NewPdfViewer fileArray={fileArray ?? []} uiPermissionType={UI_PERMISSION_TYPE.READABLE} />
      </div>
    </div>
  );
};

export default DevTicketsListBody;
